import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { BrandsProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { fetchBrands } from 'queries/brands/brands'

export function useGetBrands({
    env,
    accessToken,
    location,
    filters,
}: BrandsProps) {
    const { tenMinutes } = TIME
    const { trackEvent } = useAnalytics()
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.BRANDS, location, filters],
        () =>
            fetchBrands({
                env,
                accessToken,
                filters,
                method: 'GET',
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
